import lang from '../../../Translation/Ladning.json';

const Caj = ({ data = [] }) => {
  const text = lang.Card;

  // 🔹 Calculate total charges
  const totalCharges = data.reduce((sum, item) => sum + item.charge, 0);

  // 🔹 Count unique units (avoid duplicates)
  const uniqueUnits = new Set(data.map((item) => item.unitNumber));
  const totalUnits = uniqueUnits.size;

  // 🔹 Group charges by zone
  const zoneTotals = data.reduce((acc, item) => {
    const zoneKey = item.zone?.toLowerCase() || 'unknown';
    acc[zoneKey] = (acc[zoneKey] || 0) + item.charge;
    return acc;
  }, {});

  // 🔹 Calculate percentage by zone
  const getZonePercentage = (zone) => {
    const value = zoneTotals[zone] || 0;
    return totalCharges ? ((value / totalCharges) * 100).toFixed(2) : 0;
  };

  // 🔹 Latest receipt date
  const latestDate =
    data.length > 0
      ? new Date(
          Math.max(...data.map((item) => new Date(item.receiptDate)))
        ).toISOString()
      : null;

  return (
    <div className="p-5 rounded-md border border-sky-500 bg-sky-300 shadow-md">
      <h2 className="text-xl mb-3 font-semibold uppercase">
        {text.Total_Charges}
      </h2>

      <div>
        <p className="text-lg">
          {text.amount} :
          <span className="text-xl ms-1 font-medium">
            RM {Number(totalCharges).toLocaleString(undefined, { maximumFractionDigits: 2 })}
          </span>
        </p>

        <p className="text-lg">
          {text.number_of_units} :
          <span className="text-xl ms-1 font-medium">
            {Number(totalUnits).toLocaleString()} {text.unit}
          </span>
        </p>
      </div>

      <hr className="my-4 border-gray-600" />

      {/* 🔹 Show Zone Percentages */}
      <div className="space-y-2">
        {[1, 2, 3, 4].map((z) => (
          <div key={z} className="flex justify-between items-center">
            <p className="text-lg font-medium">{`Zone ${z}`}</p>
            <p className="text-lg">{getZonePercentage(`zone${z}`)}%</p>
          </div>
        ))}
      </div>

      {/* 🔹 Latest Date */}
      <div className="flex justify-end items-center mt-4">
        <p className="text-sm text-gray-700">
          {text.date}:{" "}
          {latestDate
            ? new Date(latestDate).toLocaleDateString("en-GB")
            : "N/A"}
        </p>
      </div>
    </div>
  );
};

export default Caj;
